import React from 'react';
import { useLenis } from '../lib/useLenis';
import { Experience } from '../components/scene/Experience';
import { Nav } from '../components/sections/Nav';
import { Hero } from '../components/sections/Hero';
import { Manifesto } from '../components/sections/Manifesto';
import { EditorialMarquee } from '../components/sections/EditorialMarquee';
import { EstimateTeaser } from '../components/sections/EstimateTeaser';
import { Services } from '../components/sections/Services';
import { Gallery } from '../components/sections/Gallery';
import { Testimonials } from '../components/sections/Testimonials';
import { Footer } from '../components/sections/Footer';

const Home = () => {
    useLenis();
    return (
        <div className="relative min-h-screen bg-ink-900 text-bone-100 vignette" data-testid="msd-home">
            {/* Fixed 3D canvas backdrop */}
            <Experience />

            {/* Grain overlay */}
            <div className="grain-overlay" />

            {/* Fixed nav */}
            <Nav />

            {/* Scrolling content over the canvas */}
            <main className="relative z-20">
                <Hero />
                {/* Give the 3D story room to breathe before content overlays start */}
                <div style={{ height: '30vh' }} aria-hidden="true" />

                {/* Chapter I → II: exterior renewing while we read manifesto */}
                <Manifesto />

                <EditorialMarquee />

                <EstimateTeaser />

                {/* Chapter V: interior journey */}
                <Services />

                <Gallery />

                <Testimonials />

                <Footer />
            </main>
        </div>
    );
};

export default Home;
